import styled from 'styled-components';
import Icon from 'js/components/common/Icon';
import { greenColor } from 'js/config/style';

export default styled(Icon)`
  color: ${greenColor};
  align-self: start;
  justify-self: center;
  font-size: 1.5rem;
  line-height: 1.5rem;
`;
